import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import moment from 'moment';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputField, DateField, required, parseDecimal, dateGtnDate, dateGtnToday, minValue } from '../../../form';
import { currencyFormat } from '../../../../utils/helpers/currency';

class CampaignDetails extends Component {
  endDateValidation = (endDate, allValues) => {
    if (endDate) {
      const validGtnDate = dateGtnDate(endDate, allValues.start_date);
      const validTdyDate = dateGtnToday(endDate);

      if (validTdyDate) return validTdyDate;
      if (validGtnDate) return validGtnDate;
    }

    return undefined;
  };

  render() {
    const { recurringChecked, formAction, targetApplicants, targetCpa, selectedJobs } = this.props;

    const clicksRequired = (100 / 5) * targetApplicants;
    const cpcValue = (5 / 100) * targetCpa;
    const monthlyBudget = clicksRequired * cpcValue * selectedJobs.length;

    return (
      <div>
        <Row>
          <Col md={12}>
            <Field type="text" name="name" placeholder="Name of the campaign" label="Campaign Name" component={InputField} validate={[required]} />
          </Col>
        </Row>
        {formAction === 'Wizard' && (
          <div>
            <Row>
              <Col md={12}>
                <Field
                  type="number"
                  name="applicants"
                  placeholder="Please enter the number of the target applicants per job"
                  label="Target Applicants per Job"
                  component={InputField}
                  validate={[required, minValue(1)]}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Field
                  type="number"
                  name="cpa"
                  placeholder="Please enter target cost per applicants"
                  label="Target CPA ($)"
                  component={InputField}
                  validate={[required, minValue(0.01)]}
                />
              </Col>
            </Row>
          </div>
        )}
        {this.props.children}
        <Row>
          <Col md={12}>
            <Field
              type="number"
              name="budget"
              placeholder="Please enter the budget amount"
              label="Monthly Budget ($)"
              component={InputField}
              validate={[required, minValue(1)]}
              parse={value => {
                return parseDecimal(value);
              }}
            />
          </Col>
        </Row>
        {formAction === 'Wizard' && (
          <Row>
            <Col md={12}>
              <span style={{ color: '#1c84c6' }}>Suggested Monthly Budget:</span>&nbsp;&nbsp;
              <span style={{ color: '#1ab394' }}>{monthlyBudget > 0 ? currencyFormat(monthlyBudget) : null}</span>
              <br /> <br />
            </Col>
          </Row>
        )}
        {(formAction === 'Create' || formAction === 'Wizard') && (
          <Row>
            <Col md={12}>
              <Field
                type="number"
                name="bid"
                placeholder="Please enter the default cost per click"
                label="Default CPC ($)"
                infoText="This amount will be used for any jobs that have no specified bid."
                component={InputField}
                validate={[required, minValue(0.01)]}
                value="0"
                normalize={value => {
                  return parseDecimal(value);
                }}
              />
            </Col>
          </Row>
        )}
        {formAction === 'Wizard' && (
          <Row>
            <Col md={12}>
              <span style={{ color: '#1c84c6' }}>Suggested CPC:</span>&nbsp;&nbsp;
              <span style={{ color: '#1ab394' }}>{cpcValue > 0 ? currencyFormat(cpcValue) : null}</span>
              <br /> <br />
            </Col>
          </Row>
        )}
        <Row>
          <Col md={12}>
            <label htmlFor="recurring">
              Recurring&nbsp;
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="recurring-overlay-tooltip" style={{ zIndex: 10001 }}>
                    If this is checked the budget will automatically be reset at the beginning of the month.
                  </Tooltip>
                }
              >
                <FontAwesomeIcon icon="question-circle" />
              </OverlayTrigger>
            </label>
            &nbsp; &nbsp;
            <Field type="checkbox" component="input" name="recurring" id="recurring" />
          </Col>
        </Row>
        <br />
        <Row>
          <Col md={12}>
            <Field
              type="date"
              name="start_date"
              placeholder="Please select a start date"
              label="Start Date"
              component={DateField}
              props={{
                disabled: formAction === 'Update',
              }}
              validate={[required]}
              placement="top"
              minDate={moment()}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Field
              type="date"
              name="end_date"
              placeholder="Please select a end date after the start date"
              label="End Date"
              component={DateField}
              placement="top"
              props={{
                disabled: recurringChecked,
              }}
              validate={recurringChecked ? [] : [required, this.endDateValidation]}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const recurringChecked = state?.form?.campaignWizardForm?.values?.recurring || false;
  const targetApplicants = state?.form?.campaignWizardForm?.values?.applicants || 0;
  const targetCpa = state?.form?.campaignWizardForm?.values?.cpa || 0;
  const selectedJobs = ownProps?.selected || [];

  return {
    recurringChecked,
    targetApplicants,
    targetCpa,
    selectedJobs,
  };
};

export default connect(mapStateToProps)(CampaignDetails);
